// Onboarding ending — member summary card (inspired by dashboard hero, not identical;
// no org division/branch/section row).

import React from 'react';
import avatarStructure from '../../../../medias/avatar_ring.png';
import discordAvatarDefault from '../../../../medias/avatar_default.png';

export default function OnboardingHero({ player, onDiscordAvatarError }) {
  return (
    <section className="members-onboarding-hero" aria-label="Member summary">
      <div className="members-onboarding-hero__inner">
        <div className="members-onboarding-hero__identity">
          <div className="members-onboarding-hero__avatar-stack">
            <img
              className="members-onboarding-hero__avatar-discord"
              src={player?.discordAvatar || discordAvatarDefault}
              onError={onDiscordAvatarError}
              alt="Member avatar"
            />
            <img className="members-onboarding-hero__avatar-frame" src={avatarStructure} alt="" />
          </div>
        </div>

        <div className="members-onboarding-hero__divider" aria-hidden />

        <div className="members-onboarding-hero__meta">
          <div className="members-onboarding-hero__rank-row">
            <div className="members-onboarding-hero__rank-icon-slot">
              {player?.rankImageUrl ? (
                <img className="members-onboarding-hero__rank-icon" src={player.rankImageUrl} alt="" />
              ) : (
                <span className="members-onboarding-hero__rank-icon--empty" aria-hidden />
              )}
            </div>

            <div className="members-onboarding-hero__rank-text">
              <p className="members-onboarding-hero__rank-name">{player?.rankName || '—'}</p>

              <p className="members-onboarding-hero__pay-grade">
                {player?.payGrade ? `Pay grade ${player.payGrade}` : '—'}
              </p>

              {player?.rosterAssignmentDisplay ? (
                <p className="members-onboarding-hero__assignment">{player.rosterAssignmentDisplay}</p>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
